import axios from "axios";
import { getCurrentTokenPost  } from "./context/UserContext";
import swal from "sweetalert";
// Removed: import notify from "devextreme/ui/notify";

// const isProd = process.env.NODE_ENV === "production";

axios.defaults.baseURL = "https://digibima.acreafrica.com/digibimaprod";
// axios.defaults.baseURL = "http://localhost:23098/";
// axios.defaults.baseURL = isProd
//   ? "http://20.164.220.70:85/digibimv2/"
//   : "http://localhost:23098//";

axios.interceptors.request.use((config) => {
  const token = getCurrentTokenPost ();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.headers.common["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.withCredentials = false;

axios.interceptors.response.use(
  (response) => {
    console.log("Success:", response?.status); // ✅ log success message
    return response;
  },
  (error) => {
    if (error.response?.status) {
      const { data, status } = error.response;
      switch (status) {
        case 400:
          if (data?.errors) {
            const modelStateErrors = [];
            for (let key in data.errors) {
              if (data.errors[key]) {
                modelStateErrors.push(data.errors[key]);
              }
            }
            swal({
              title: "Error!",
              text: modelStateErrors.flat().join("\n"),
              icon: "error",
            });
          } else {
            swal({
              title: "Error!",
              text: data,
              icon: "error",
            });
          }
          break;
        case 403:
        case 401:
          swal({
            title: "Unauthorized!",
            text: "You are not authorised to access this page.",
            icon: "error",
          });
          break;
        case 404:
          swal({
            title: "Not found",
            text: "This resource is not available at the moment.",
            icon: "error",
          });
          break;
        case 500:
        case 501:
        case 503:
          swal({
            title: "Server error",
            text: data,
            icon: "error",
          });
          break;
        default:
          console.error("Failed to load resources");
      }
    } else if (error.request) {
      console.error("Network error");
    } else {
      console.error("Network error. Try again later");
    }
  }
);

const responseBody = (response) => response?.data;

const requests = {
  get: (url) => axios.get(url).then(responseBody),
  post: (url, body = {}) => axios.post(url, body).then(responseBody),
  put: (url, body = {}) => axios.put(url, body).then(responseBody),
  del: (url) => axios.delete(url).then(responseBody),
};

export default requests;
